import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const ViewListSolidIcon = forwardRef<SVGSVGElement, IconProps>(function ViewListSolidIcon(
  { color, height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4C2 3.46957 2.18437 2.96086 2.51256 2.58579C2.84075 2.21071 3.28587 2 3.75 2H14.25C14.7141 2 15.1592 2.21071 15.4874 2.58579C15.8156 2.96086 16 3.46957 16 4V6C16 6.53043 15.8156 7.03914 15.4874 7.41421C15.1592 7.78929 14.7141 8 14.25 8H3.75C3.28587 8 2.84075 7.78929 2.51256 7.41421C2.18437 7.03914 2 6.53043 2 6V4ZM2 12C2 11.4696 2.18437 10.9609 2.51256 10.5858C2.84075 10.2107 3.28587 10 3.75 10H14.25C14.7141 10 15.1592 10.2107 15.4874 10.5858C15.8156 10.9609 16 11.4696 16 12V14C16 14.5304 15.8156 15.0391 15.4874 15.4142C15.1592 15.7893 14.7141 16 14.25 16H3.75C3.28587 16 2.84075 15.7893 2.51256 15.4142C2.18437 15.0391 2 14.5304 2 14V12Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
